import { render, staticRenderFns } from "./Sent-messages.vue?vue&type=template&id=ded953c2&scoped=true"
import script from "./Sent-messages.vue?vue&type=script&lang=js"
export * from "./Sent-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded953c2",
  null
  
)

export default component.exports